import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiTab: Components<Theme>['MuiTab'] = {
  styleOverrides: {
    root: () => ({
      color: '#525E7E',
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '21px',
      textTransform: 'none',
      padding: '12px',
      '&.Mui-selected': {
        color: '#6948EB',
      },
      '@media (max-width: 600px)': {
        padding: '12px 0',
      },
    }),
  },
};
